export default function PaintingServices() {
  const services = [
    {
      icon: 'ri-home-4-line',
      title: 'Interior Painting',
      description: 'Professional interior painting for walls, ceilings, trim, and cabinets with premium quality paints and finishes'
    },
    {
      icon: 'ri-building-line',
      title: 'Exterior Painting',
      description: 'Weather-resistant exterior painting services to protect and beautify your home against El Paso\'s harsh climate'
    },
    {
      icon: 'ri-paint-brush-line',
      title: 'Cabinet Refinishing',
      description: 'Transform your kitchen and bathroom cabinets with expert refinishing and painting services'
    },
    {
      icon: 'ri-contrast-2-line',
      title: 'Color Consultation',
      description: 'Professional color matching and consultation to help you choose the perfect palette for your space'
    },
    {
      icon: 'ri-tools-line',
      title: 'Drywall Repair',
      description: 'Complete drywall repair and preparation services before painting for a flawless finish'
    },
    {
      icon: 'ri-store-2-line',
      title: 'Commercial Painting',
      description: 'Professional commercial painting services for offices, retail spaces, and industrial facilities'
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Comprehensive Painting Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From interior transformations to exterior protection, our El Paso painting contractors deliver exceptional results for every project
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-xl border border-gray-200 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-16 h-16 bg-teal-600 rounded-lg flex items-center justify-center mb-6">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
